import React, { useState } from "react"

import classNames from "classnames"

import { Link as GatsbyLink } from "gatsby"
import {
  Toolbar,
  Container,
  Link,
  Button,
  Box,
  Hidden,
  IconButton,
  Popper,
  makeStyles,
} from "@material-ui/core"

import { Menu as MenuIcon } from "@material-ui/icons"
import { Paper } from "../../../components"

const useStyles = makeStyles(theme => ({
  toolbar: {
    backgroundColor: theme.palette.common.white,
    borderBottom: `1px solid ${theme.palette.border}`,
    position: "fixed",
    top: 0,
    width: "100%",
    zIndex: theme.zIndex.appBar,
  },
  navLink: {
    color: theme.palette.text.primary,
    fontWeight: theme.typography.fontWeightMedium,
    fontSize: theme.typography.h4.fontSize,
    "&:hover": {
      cursor: "pointer",
      color: theme.palette.text.secondary,
    },
  },
  navItem: {
    marginLeft: theme.spacing(3),
  },
  mobileNavItem: {
    marginBottom: theme.spacing(3),
  },
  mobileMenu: {
    padding: theme.spacing(2),
    listStyle: "none",
  },
}))

const navLinks = [
  {
    label: "Features",
    to: "/features",
  },
  {
    label: "Pricing",
    to: "/pricing",
  },
  {
    label: "Roadmap",
    to: "/roadmap",
  },
  {
    label: "Support",
    href: "https://kovalt.freshdesk.com",
    rel: "noreferrer noopener",
    target: "_blank",
  },
  {
    label: "Login",
    href: "https://app.kovalt.io/signin",
    rel: "noreferrer noopener",
    target: "_blank",
  },
]

const Header = () => {
  const classes = useStyles()

  const [anchorEl, setAnchorEl] = useState()

  const handleMenuToggle = e => setAnchorEl(anchorEl ? null : e.currentTarget)

  return (
    <Toolbar component="header" className={classes.toolbar} dense={false}>
      <Container maxWidth="md">
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Box display="flex">
            <GatsbyLink to="/">
              <img
                src={"/kovalt_logos/kovalt_logo_violet.svg"}
                alt="logo"
                style={{ height: 36 }}
              />
            </GatsbyLink>
          </Box>
          <Hidden smDown>
            <Box display="flex" alignItems="center">
              {navLinks.map(({ label, to, ...other }, k) => (
                <Link
                  key={k}
                  className={classNames(classes.navLink, classes.navItem)}
                  component={to ? GatsbyLink : "a"}
                  to={to}
                  {...other}
                >
                  {label}
                </Link>
              ))}
              <Button
                className={classes.navItem}
                variant="contained"
                color="primary"
                href="https://app.kovalt.io/signup"
                rel="noreferrer noopener"
                target="_blank"
              >
                Get started
              </Button>
            </Box>
          </Hidden>
          <Hidden mdUp>
            <IconButton onClick={handleMenuToggle}>
              <MenuIcon />
            </IconButton>
            <Popper
              open={!!anchorEl}
              anchorEl={anchorEl}
              onClose={handleMenuToggle}
            >
              <Paper>
                <ul className={classes.mobileMenu}>
                  {navLinks.map(({ label, to, ...other }, k) => (
                    <li className={classes.mobileNavItem}>
                      <Link
                        key={k}
                        className={classes.navLink}
                        component={to ? GatsbyLink : "a"}
                        to={to}
                        {...other}
                      >
                        {label}
                      </Link>
                    </li>
                  ))}
                  <li className={classes.mobileNavItem}>
                    <Button
                      variant="contained"
                      color="primary"
                      href="https://app.kovalt.io/signup"
                      rel="noreferrer noopener"
                      target="_blank"
                      fullWidth
                    >
                      Get started
                    </Button>
                  </li>
                </ul>
              </Paper>
            </Popper>
          </Hidden>
        </Box>
      </Container>
    </Toolbar>
  )
}

export default Header
